'use client';

import { c } from 'ui-components';
import { Skeleton } from './Skeleton';

type ProductCardSkeletonProps = {
  className?: string;
};

export const ProductCardSkeleton = ({
  className,
}: ProductCardSkeletonProps) => {
  return (
    <div
      className={c(
        'flex w-full animate-pulse flex-col rounded-lg bg-surface',
        className
      )}
    >
      <Skeleton className="aspect-3/2 rounded-t-lg" />
      <div className="flex h-40 flex-col gap-3 border-x border-b border-line px-3 pb-3 pt-3">
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-5 w-1/3" />
        <Skeleton className="h-5 w-1/2" />
        <Skeleton className="h-5 w-16" />
      </div>
    </div>
  );
};
